import { cva, type VariantProps } from 'class-variance-authority';

export const segmentedVariants = cva('inline-flex items-center justify-center p-1 text-muted-foreground', {
  variants: {
    zSize: {
      sm: 'h-9 text-xs',
      default: 'h-10 text-sm',
      lg: 'h-12 text-base',
    },
    zVariant: {
      default: 'rounded-base',
      rounded: 'rounded-full',
    },
    zSeverity: {
      default: 'bg-muted',
      'ai-light-gradient': 'ai-light-gradient-base',
    },
  },
  defaultVariants: {
    zSize: 'default',
    zVariant: 'default',
    zSeverity: 'default',
  },
});

export const segmentedItemVariants = cva(
  'inline-flex items-center justify-center whitespace-nowrap px-3 py-1.5 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50',
  {
    variants: {
      zSize: {
        sm: 'px-2 py-1 text-xs',
        default: 'px-3 py-1.5 text-sm',
        lg: 'px-4 py-2 text-base',
      },
      isActive: {
        true: 'text-foreground shadow-sm',
        false: 'hover:bg-muted/50',
      },
      zVariant: {
        default: 'rounded-base',
        rounded: 'rounded-full',
      },
      zSeverity: {
        default: '',
        'ai-light-gradient': '',
      },
    },
    compoundVariants: [
      {
        isActive: true,
        zSeverity: 'ai-light-gradient',
        class: 'ai-light-gradient',
      },
      {
        isActive: true,
        zSeverity: 'default',
        class: 'bg-white',
      },
    ],
    defaultVariants: {
      zSize: 'default',
      isActive: false,
      zVariant: 'default',
      zSeverity: 'default',
    },
  },
);

export type ZardSegmentedVariants = VariantProps<typeof segmentedVariants>;
export type ZardSegmentedItemVariants = VariantProps<typeof segmentedItemVariants>;
